// extracted by mini-css-extract-plugin
export var sliderRange = "_n1-2";
export var sliderRoot = "_n1-0";
export var sliderThumb = "_n1-3";
export var sliderTrack = "_n1-1";